import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  selectRow: () => __(translations.expansionBreadCrumbs.selectRow, 'Select a row…'),
};
